import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-bd4264c6.js';
import { I as Icon } from './chunk-0928016a.js';
export { I as BIcon } from './chunk-0928016a.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Icon);
  }
};
use(Plugin);
export default Plugin;